
import ProducerSearch from '@/components/baseForm/ProducerSearch.vue'
import {
  hydrateOfflineCache,
  persistOfflineCache,
  validateOfflineCache
} from '@/api/offlineCache'
import {
  hydrateOfflineAuditEvents,
  persistOfflineAuditEvents
} from '@/api/offlineAudit'

export default {
  data () {
    return {
      initialLoadCompleted: false,
      isClient: false,
      clipped: true,
      drawer: true,
      syncing: false,
      persistTimer: null,
      auditPersistTimer: null,
      unsubscribeStorePersistence: null,
      onlineListener: null,
      offlineListener: null,
      openOrderCard: false,
      openUsageCard: false,
      usageData: {},
      orderData: {},
      searchOptions: [
        {
          text: 'Producer Search',
          value: 'BaseFormProducerSearch'
        },
        {
          text: 'Owner Search',
          value: 'BaseFormOwnerSearch'
        },
        {
          text: 'Farm Unit Search',
          value: 'BaseFormFarmunitSearch'
        }
      ],
      afterPrecache: false,
      searchValue: 'BaseFormProducerSearch',
      menuItems: [
        {
          icon: 'mdi-database-sync',
          key: 'dock',
          title: 'Dock',
          to: '/dock'
        },
        {
          icon: 'mdi-monitor-dashboard',
          key: 'home',
          title: 'Dashboard',
          to: '/'
        },
        {
          icon: 'mdi-water-pump',
          key: 'orders',
          title: 'Orders',
          to: '/pg/orders'
        },
        {
          icon: 'mdi-account-box',
          key: 'contacts',
          title: 'Contacts',
          to: '/pg/contacts'
        },
        {
          icon: 'mdi-waves',
          key: 'waterMasterReport',
          title: 'Water Master Report',
          to: '/waterMasterReport'
        },
        {
          icon: 'mdi-home-silo-outline',
          key: 'farmunits',
          title: 'Farm Units',
          to: '/pg/farmunits'
        },
        {
          icon: 'mdi-link-variant',
          key: 'reconciliation',
          title: 'Reconciliation',
          to: '/reconciliation'
        },
        {
          icon: 'mdi-chart-bar',
          key: 'reports',
          title: 'Reports',
          to: '/reports'
        },
        {
          icon: 'mdi-clipboard-text-clock-outline',
          key: 'auditLog',
          title: 'Audit Log',
          to: '/waterAudit',
          adminOnly: true
        },
        {
          icon: 'mdi-database-eye-outline',
          key: 'offlineAudit',
          title: 'Offline Audit',
          to: '/offlineAudit',
          adminOnly: true
        }

      ],
      settings: [
        {
          icon: 'mdi-map',
          key: 'divisions',
          title: 'Divisions',
          to: '/pg/divisions'
        },
        {
          icon: 'mdi-waves',
          key: 'ditches',
          title: 'Ditches',
          to: '/pg/ditches'
        },
        {
          icon: 'mdi-cog',
          key: 'omsettings',
          title: 'O&M Settings',
          to: '/pg/omsettings'
        },
        {
          icon: 'mdi-flag',
          key: 'flags',
          title: 'Flags',
          to: '/pg/flags'
        },
        {
          icon: 'mdi-wifi-off',
          key: 'offlineRequests',
          title: 'Offline Requests',
          to: '/pg/offlineRequests'
        }
      ],
      adminsettings: [
        {
          icon: 'mdi-map',
          key: 'divisions',
          title: 'Divisions',
          to: '/pg/divisions'
        },
        {
          icon: 'mdi-waves',
          key: 'ditches',
          title: 'Ditches',
          to: '/pg/ditches'
        },
        {
          icon: 'settings',
          key: 'omsettings',
          title: 'O&M Settings',
          to: '/pg/omsettings'
        },
        {
          icon: 'flags',
          key: 'flags',
          title: 'Flags',
          to: '/pg/flags'
        },
        {
          icon: 'mdi-wifi-off',
          key: 'offlineRequests',
          title: 'Offline Requests',
          to: '/pg/offlineRequests'
        },
        {
          icon: 'mdi-clipboard-search-outline',
          key: 'waterAudit',
          title: 'Water Audit',
          to: '/waterAudit'
        },
        {
          icon: 'mdi-link-variant',
          key: 'reconciliation',
          title: 'Reconciliation',
          to: '/reconciliation'
        },
        {
          icon: 'mdi-database-eye-outline',
          key: 'offlineAudit',
          title: 'Offline Audit',
          to: '/offlineAudit'
        }
      ],
      notifications: [],
      miniVariant: true,
      localForageOverrides: {
        system: ['waterYear', 'availableWaterYears', 'offlinePushRequests'],
        omsettings: ['omOfYear']
      }
    }
  },
  computed: {
    ProducerSearch () {
      return ProducerSearch
    },
    loadCount: {
      get () {
        return this.$store.state.system.loadCount
      },
      set (value) {
        this.$store.commit('system/SET_LOADCOUNT', value)
      }
    },
    loadStatus: {
      get () {
        return this.$store.state.system.loadStatus
      },
      set (value) {
        this.$store.commit('system/SET_LOADSTATUS', value)
      }
    },
    ordersPage () {
      return this.$route.name === 'pg-orders' || this.$route.name === 'pg-orders-id'
    },
    offlineRequestsPage () {
      return !this.isEmpty(this.$route.params) && this.$route.params.slug === 'offlineRequests'
    },
    storeState () {
      return this.$store.state
    },
    offlineCacheStatus () {
      return this.$store.state.system.offlineCacheStatus || {}
    },
    pendingOfflineRequests () {
      return this.$store.getters['system/offlineRequests'] || []
    },
    offlineCacheReady () {
      return Boolean(this.offlineCacheStatus.ready) && this.pendingOfflineRequests.length === 0
    },
    offlineCacheTooltip () {
      if (this.offlineCacheReady) {
        const savedAt = this.offlineCacheStatus.savedAt
        return savedAt ? `Field data cached ${this.$moment(savedAt).format('MM/DD/YYYY h:mm A')}` : 'Field data is cached and ready.'
      }

      const missing = this.offlineCacheStatus.missingStores || []
      if (missing.length) {
        return `Dock needed. Missing: ${missing.join(', ')}`
      }

      const relationIssues = this.offlineCacheStatus.relationIssues || []
      if (relationIssues.length) {
        return 'Dock needed. Cached field data has unresolved relations.'
      }

      if (this.pendingOfflineRequests.length) {
        return `${this.pendingOfflineRequests.length} offline request${this.pendingOfflineRequests.length === 1 ? ' is' : 's are'} still pending.`
      }

      return 'Dock needed before offline field work.'
    },
    loadStores () {
      return this.$store.state.system.loadStores
    },
    waterYear () {
      return this.$store.getters['system/getWaterYear']
    },
    waterYears () {
      return this.$store.getters['system/getAllWaterYears']
    },
    latestWaterYear () {
      return this.$store.getters['system/getLatestWaterYear']
    },
    roles () {
      return this.$store.getters['system/roles']
    },
    is_readonly () {
      return this.$store.getters['system/isReadonly']
    },
    is_admin () {
      return this.roles.includes('admin') ||
                this.roles.includes('superAdmin') ||
                this.roles.includes('super admin')
    },
    visibleMenuItems () {
      return this.menuItems.filter((item) => {
        return !item.adminOnly || this.is_admin
      })
    }
  },
  watch: {
    drawer (n, o) {
      if (n === false) {
        this.miniVariant = true
      }
    },
    '$vuetify.breakpoint.mobile': {
      immediate: true,
      handler (n, o) {
        if (n) {
          this.miniVariant = false
        }
      }
    }
  },
  beforeMount () {
    this.isClient = false
  },
  beforeDestroy () {
    if (this.unsubscribeStorePersistence) {
      this.unsubscribeStorePersistence()
    }
    if (this.persistTimer) {
      clearTimeout(this.persistTimer)
    }
    if (this.auditPersistTimer) {
      clearTimeout(this.auditPersistTimer)
    }
    if (this.onlineListener) {
      window.removeEventListener('online', this.onlineListener)
    }
    if (this.offlineListener) {
      window.removeEventListener('offline', this.offlineListener)
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.onmessage = (e) => {
        if (e.data === 'afterPrecache') {
          this.afterPrecache = true
        }
      }
    } else {
      this.afterPrecache = true
    }

    await this.initializeApp()
  },
  methods: {
    async initializeApp () {
      this.loadCount = Object.values(this.storeState).length + 5
      this.loadStatus = 0
      this.$nextTick(() => {
        this.$nuxt.$loading.start()
      })

      try {
        await this.getLocalForageToState()
        await this.getOfflineAuditEventsToState()
        this.addNetworkAuditListeners()
        await this.recordOfflineAudit('app_boot_completed', {
          hydrated_store_count: Object.keys(this.$store.state).length
        })
        await this.$store.dispatch('syncStats/show', 1)
        await this.$store.dispatch('syncHistory/list')

        this.loadStatus++
        this.splitWaitNoWait()
        this.loadStatus++
        await this.fetchLatestDataWait()
        this.loadStatus++
        await this.checkOMSettings(this.$store.state.system.waterYear || this.latestWaterYear)
        this.loadStatus++
        this.fetchLatestDataNoWait()
        this.loadStatus++
      } catch (error) {
        await this.handleInitialLoadError(error)
      } finally {
        this.$nuxt.$loading.finish()
        this.loadCount = 0
        this.loadStatus = 0
        this.isClient = true
        this.initialLoadCompleted = true
        this.startOfflineCachePersistence()
        this.scheduleOfflineCachePersist()
      }
    },
    async handleInitialLoadError (error) {
      const message = error?.message || 'The app could not finish loading field data.'
      console.error('Initial app load failed.', error)
      try {
        await this.recordOfflineAudit('app_boot_failed', { message }, 'error')
      } catch (auditError) {
        console.warn('Unable to record initial load failure.', auditError)
      }
      this.$store.dispatch('snackbar/showMessage', {
        content: { message },
        color: 'error'
      }, { root: true })
    },
    debugStoreTokens () {
      if (typeof window === 'undefined') {
        return []
      }

      const raw = window.localStorage.getItem('debugStoreLoad')
      if (!raw) {
        return []
      }

      return raw
        .split(',')
        .map(token => token.trim())
        .filter(Boolean)
    },
    shouldDebugStore (store = 'app') {
      const tokens = this.debugStoreTokens()
      if (!tokens.length) {
        return false
      }
      return tokens.includes('*') || tokens.includes('all') || tokens.includes(store)
    },
    debugStore (store, stage, details = {}) {
      if (!this.shouldDebugStore(store)) {
        return
      }
      console.info(`[store-hydration:${store}] ${stage}`, details)
    },
    countItems (value) {
      if (Array.isArray(value)) {
        return value.length
      }
      if (value && typeof value === 'object') {
        return Object.keys(value).length
      }
      return 0
    },
    openOrderForm (data) {
      this.orderData = data
      this.openOrderCard = true
    },
    reloadApp () {
      window.location.reload()
    },
    openUsageForm (data) {
      this.usageData = data
      this.openUsageCard = true
    },
    closeOrderForm () {
      this.orderData = {}
      this.openOrderCard = false
    },
    closeUsageForm () {
      this.usageData = {}
      this.openUsageCard = false
    },
    toggleMenu () {
      if (this.$vuetify.breakpoint.mobile) {
        this.miniVariant = false
        this.drawer = !this.drawer
      } else {
        this.miniVariant = !this.miniVariant
      }
    },
    async getLocalForageToState () {
      this.debugStore('app', 'localforage:start')
      const { hydratedStores, manifest } = await hydrateOfflineCache(this.$localForage, this.$store, { online: navigator.onLine })
      hydratedStores.forEach((store) => {
        this.debugStore(store, 'localforage:replace-all', {
          count: this.countItems(this.$store.state[store]?.all)
        })
        this.loadStatus++
      })
      if (manifest) {
        this.$store.commit('system/SET_OFFLINE_CACHE_MANIFEST', manifest)
      }
      this.updateOfflineCacheStatus(manifest)
      const waterYear = this.$store.state.system.waterYear
      if (waterYear) {
        await this.$store.dispatch('system/setWaterYear', waterYear)
      }
    },
    async saveStatetoLocalForage () {
      if (this.isOfflineCachePersistPaused()) {
        return null
      }
      const statusBeforePersist = validateOfflineCache(this.$store.state, this.$store.state.system.offlineCacheManifest)
      this.$store.commit('system/SET_OFFLINE_CACHE_STATUS', statusBeforePersist)
      if (!statusBeforePersist.ready) {
        this.debugStore('app', 'localforage:persist-skipped-invalid', statusBeforePersist)
        return null
      }
      const manifest = await persistOfflineCache(this.$localForage, this.$store.state, this.$auth?.user?.data)
      this.$store.commit('system/SET_OFFLINE_CACHE_MANIFEST', manifest)
      this.updateOfflineCacheStatus(manifest)
      return manifest
    },
    startOfflineCachePersistence () {
      if (this.unsubscribeStorePersistence) {
        return
      }
      this.unsubscribeStorePersistence = this.$store.subscribe((mutation) => {
        if (
          mutation.type.startsWith('offlineAudit/')
        ) {
          this.scheduleOfflineAuditPersist()
          return
        }
        if (
          mutation.type === 'system/SET_OFFLINE_CACHE_STATUS' ||
          mutation.type === 'system/SET_OFFLINE_CACHE_MANIFEST' ||
          mutation.type === 'system/SET_OFFLINE_CACHE_PERSIST_PAUSED'
        ) {
          return
        }
        if (!this.initialLoadCompleted || this.isOfflineCachePersistPaused()) {
          return
        }
        this.scheduleOfflineCachePersist()
      })
    },
    scheduleOfflineCachePersist () {
      if (!this.initialLoadCompleted || this.isOfflineCachePersistPaused()) {
        return
      }
      if (this.persistTimer) {
        clearTimeout(this.persistTimer)
      }
      this.persistTimer = setTimeout(() => {
        this.saveStatetoLocalForage()
      }, 750)
    },
    scheduleOfflineAuditPersist () {
      if (this.auditPersistTimer) {
        clearTimeout(this.auditPersistTimer)
      }
      this.auditPersistTimer = setTimeout(() => {
        this.saveOfflineAuditEventsToLocalForage()
      }, 250)
    },
    async getOfflineAuditEventsToState () {
      if (!this.$store.state.offlineAudit) {
        return
      }
      const events = await hydrateOfflineAuditEvents(this.$localForage)
      await this.$store.dispatch('offlineAudit/hydrate', events)
    },
    async saveOfflineAuditEventsToLocalForage () {
      if (!this.$store.state.offlineAudit) {
        return []
      }
      return await persistOfflineAuditEvents(this.$localForage, this.$store.state.offlineAudit.events)
    },
    async recordOfflineAudit (event, details = {}, severity = 'info') {
      if (!this.$store.state.offlineAudit) {
        return null
      }
      return await this.$store.dispatch('offlineAudit/record', {
        event,
        severity,
        details
      })
    },
    addNetworkAuditListeners () {
      if (typeof window === 'undefined' || this.onlineListener || this.offlineListener) {
        return
      }
      this.onlineListener = () => {
        this.recordOfflineAudit('network_online', {}, 'info')
      }
      this.offlineListener = () => {
        this.recordOfflineAudit('network_offline', {}, 'warning')
      }
      window.addEventListener('online', this.onlineListener)
      window.addEventListener('offline', this.offlineListener)
    },
    isOfflineCachePersistPaused () {
      return Boolean(this.$store.state.system.offlineCachePersistPaused)
    },
    updateOfflineCacheStatus (manifest = null) {
      const status = validateOfflineCache(this.$store.state, manifest)
      this.$store.commit('system/SET_OFFLINE_CACHE_STATUS', status)
    },
    splitWaitNoWait () {
      this.noWaitStores = []
      this.waitStores = []
      for (const store of this.loadStores) {
        const lastUpdated = this.$store.getters[`${store}/lastUpdated`]
        if (lastUpdated) {
          this.noWaitStores.push(store)
        } else {
          this.waitStores.push(store)
        }
      }
      this.debugStore('app', 'splitWaitNoWait', {
        waitStores: this.waitStores,
        noWaitStores: this.noWaitStores
      })
    },
    async fetchLatestDataWait () {
      for (const store of this.waitStores) {
        const before = this.countItems(this.$store.state[store]?.all)
        this.debugStore(store, 'fetchWait:before', { count: before })
        await this.$store.dispatch(`${store}/list`)
        const after = this.countItems(this.$store.state[store]?.all)
        this.debugStore(store, 'fetchWait:after', { count: after })
      }
    },
    fetchLatestDataNoWait () {
      for (const store of this.noWaitStores) {
        const before = this.countItems(this.$store.state[store]?.all)
        this.debugStore(store, 'fetchNoWait:before', { count: before })
        const request = this.$store.dispatch(`${store}/list`)
        if (store === 'omsettings') {
          // checkOMSettings snapshots omOfYear from the hydrated cache before
          // this background fetch lands; re-derive it once fresh settings
          // merge so a mid-season settings change doesn't lag a full reload.
          request.then(() => this.refreshOMOfYear()).catch(() => {})
        }
      }
    },
    async fetchData () {
      for (const key of this.loadStores) {
        await this.$store.dispatch(`${key}/list`)
      }
    },
    async saveStateToLocalForage () {
      for (const [key, value] of Object.entries(this.storeState)) {
        if (this.objHas(value, 'all')) {
          await this.$localForage.setItem(key, value.all)
        }
      }
    },
    logout () {
      this.$auth.logout().then(() => this.$router.push('/login'))
    },
    // Quiet counterpart to checkOMSettings: refreshes the omOfYear snapshot in
    // place when a newer record is available, but never clears it and never
    // redirects — omOfYear must stay populated for everything that depends on
    // it being available.
    async refreshOMOfYear () {
      const currentYear = this.$store.state.system.waterYear || this.latestWaterYear
      const om = Object.values(this.$store.state.omsettings.all).find(
        item => item.year === currentYear
      )
      if (om) {
        await this.$store.dispatch('omsettings/set_om_of_year', om)
      }
    },
    async checkOMSettings (value = null) {
      const currentYear = value || this.latestWaterYear

      const om = Object.values(this.$store.state.omsettings.all).find(
        item => item.year === currentYear
      )
      if (!om) {
        const errorObject = {
          error: {
            data: {
              message: `OM Settings for ${currentYear} has not been set yet! Please add these in the O&M Settings page first!`
            }
          }
        }

        await this.$store.dispatch('omsettings/set_om_of_year', false)
        await this.$store.dispatch('omsettings/set_snack', errorObject)
        await this.$router.push('/pg/omsettings')
        return false
      } else {
        await this.$store.dispatch('omsettings/set_om_of_year', om)
      }

      return om
    }
  }
}
